import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Select from 'react-select';

import { ReactComponent as ClosechipIcon } from '@assets/icons/close-chip.svg';

import { toastError } from '@components/Toast';

import ApiClient from '@lib/apiClient';

const EditTeam = () => {
	const [loading, setLoading] = useState(false);
	const [departmentList, setDepartmentList] = useState([]);
	const [userList, setUserList] = useState([]);
	const [users, setUsers] = useState([]);
	const [teamLeadOptions, setTeamLeadOptions] = useState([]);
	const [teamMemberOptions, setTeamMemberOptions] = useState([]);
	const [name, setName] = useState(null);
	const [selectedDepartments, setSelectedDepartments] = useState([]);
	const [teamLead, setTeamLead] = useState(null);
	const [teamMemberIds, setTeamMemberIds] = useState([]);
	const [error, setError] = useState({});
	const navigate = useNavigate();
	const { id } = useParams();

	useEffect(() => {
		ApiClient.GET('teamOperation', id).then(({ data }) => {
			setName(data.name);
			let teamLead = {
				value: data.teamLead?.id,
				label: data.teamLead?.name
			};
			setTeamLead(teamLead);
			let teamMemberIds = data.teamMembers?.map((item) => item.id);
			setTeamMemberIds(teamMemberIds);
			let departments = data.departments?.map((item) => {
				return { value: item.id, label: item.name };
			});
			setSelectedDepartments(departments);
		});

		ApiClient.GET('getDepartmentList').then(({ data }) => {
			let departmentData = data.map((item) => {
				return { value: item.id, label: item.name };
			});
			setDepartmentList(departmentData);
		});
	}, [id]);

	useEffect(() => {
		let params = '?page=0&size=1000&status=ACTIVE';
		if (selectedDepartments && selectedDepartments.length > 0) {
			params = params + '&departmentIdList=' + selectedDepartments.map((item) => item.value).toString();
		}
		ApiClient.GET('getAdmins', params).then(({ data }) => {
			setUserList(data.data);
			let userData = data.data.map((item) => {
				return { label: item.name, value: item.id };
			});
			setUsers(userData);
		});
	}, [selectedDepartments]);

	useEffect(() => {
		setTeamLeadOptions(users.filter((item) => item.value !== teamLead?.value));
	}, [teamLead, users]);

	useEffect(() => {
		setTeamMemberOptions(users.filter((item) => !teamMemberIds.includes(item.value)));
	}, [teamMemberIds, users]);

	const onChangeTeamMembers = (selectedItem) => {
		setTeamMemberIds([...teamMemberIds, selectedItem.value]);
	};

	const onCloseTeamMember = (id) => {
		setTeamMemberIds(teamMemberIds.filter((item) => item !== id));
	};

	const validate = () => {
		let error = {};
		if (selectedDepartments.length === 0) error.department = 'Department is required';
		if (!name || name.length === 0) error.name = 'Name is required';
		if (!teamLead) error.teamLead = 'Team lead is required';
		if (teamMemberIds.length === 0) error.teamMember = 'At least one team member is required';
		setError(error);
		return error.department || error.name || error.teamLead || error.teamMember;
	};

	const onSubmit = () => {
		setLoading(true);
		let hasError = validate();
		if (hasError) return;
		let object = {
			name: name,
			teamLeadId: teamLead.value,
			teamMemberIds: teamMemberIds,
			departmentIds: selectedDepartments.map((item) => item.value)
		};
		ApiClient.PUT('teamOperation', object, id)
			.then(() => navigate('/admins/list?activeTab=TEAMS'))
			.catch((error) => {
				let message = error?.response?.message || 'Something went wrong';
				toastError(message);
			})
			.finally(() => {
				setLoading(false);
			});
	};

	return (
		<>
			<div className="brand-container role-management-container">
				<div className="form-container">
					<div className="container px-0">
						<div className="row form-row">
							<div className="col-md-12">
								<h3 className="semibold-16">Edit Team</h3>
							</div>
							<div className="col-md-12">
								<div className="form-group no-shadow-react-select">
									<label htmlFor="department">Department</label>
									<Select
										isMulti={true}
										options={departmentList}
										value={selectedDepartments}
										onChange={setSelectedDepartments}
									/>
									{error.department && <p className="error">{error.department}</p>}
								</div>
							</div>
							<div className="col-md-6 pr-10">
								<div className="form-group">
									<label htmlFor="Description">Team name</label>
									<input
										type="text"
										autoComplete="off"
										placeholder="Team name"
										name="teamMName"
										value={name}
										onChange={(event) => setName(event.target.value)}
									/>
									{error.name && <p className="error">{error.name}</p>}
								</div>
							</div>
							<div className="col-md-6 pl-10">
								<div className="form-group no-shadow-react-select">
									<label htmlFor="teamLead">Team lead</label>
									<Select
										options={teamLeadOptions}
										value={teamLead}
										onChange={setTeamLead}
									/>
									{error.teamLead && <p className="error">{error.teamLead}</p>}
								</div>
							</div>
							<div className="col-md-12">
								<div className="form-group no-shadow-react-select mb-2">
									<label htmlFor="teamMember">Team member</label>
									<Select options={teamMemberOptions} onChange={onChangeTeamMembers} />
									{error.teamMember && <p className="error">{error.teamMember}</p>}
								</div>
							</div>
							<div className="col-md-12">
								<div className="teamMember-chips">
									{userList
										?.filter((user) => teamMemberIds.includes(user.id))
										.map((user) => {
											return (
												<span className="chip" key={`chip_${user.id}`}>
													<img
														src={
															user.proPic ||
															`${process.env.PUBLIC_URL}/images/pro_pic_default.svg`
														}
													/>
													{user.name}
													<span onClick={() => onCloseTeamMember(user.id)}>
														<ClosechipIcon />
													</span>
												</span>
											);
										})}
								</div>
							</div>
						</div>

						<div className="row mb-3">
							<div className="col-md-12 text-right">
								<button
									className="button gray-outline mr-1 size32"
									onClick={() => navigate('/admins/list?activeTab=TEAMS')}
								>
									Cancel
								</button>
								<button className="button ml-1 size32" disabled={loading} onClick={onSubmit}>
									Submit
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default EditTeam;
